import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { faStar } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";

export const CatalogFavoritesEmpty: FunctionComponent = () => {
	const { t } = useTranslation();

	return (
		<div className="rounded-xl border border-dashed border-border-light bg-white p-11 text-center text-text-meta">
			<div className="mx-auto mb-3.5 flex h-11 w-11 items-center justify-center rounded-full bg-background-light">
				<Icon className="h-5 w-5 text-text-disabled" icon={faStar} />
			</div>
			<div className="mb-1.5 text-sm font-semibold text-text">
				{t("list.create.catalog.rail.favoritesEmpty.title")}
			</div>
			<div className="mx-auto max-w-sm text-xs leading-5">
				{t("list.create.catalog.rail.favoritesEmpty.description")}
			</div>
		</div>
	);
};
